<script>
import lista from '@/shared/components/crud/lista/Lista'
import listaTopo from '@/shared/components/crud/lista/ListaTopo'
import listaItens from '@/shared/components/crud/lista/ListaItens'
import listaVazia from '@/shared/components/crud/lista/ListaVazia'
export default {
    components: {
        lista, listaTopo, listaItens, listaVazia
    },
}
</script>